// react
import React, {useEffect, useState} from 'react'
import {Button, Drawer, Space, Table} from 'antd'
import Api from '@/api'
import dayjs from 'dayjs'
import FlowLogDetail from '@/pages/company/logs/detail'
import {EmptyPanel} from '@/components/elements'

interface IProps {
  flowId: string
  taskId: string
  close: () => void
}

interface IQueryEn {
  current: number
  size: number
  flowId: string
  taskId: string
}

/**
 * 流程日志
 * @constructor
 */
const FlowTaskDetailLogs = (props: IProps) => {


  const [Open, setOpen] = useState<boolean>(true)
  const [Query, setQuery] = useState<IQueryEn>({
    current: 1,
    size: 10,
    flowId: props.flowId,
    taskId: props.taskId
  })
  const [TableData, setTableData] = useState<any>()
  const [Loading, setLoading] = useState<boolean>(false)
  const [Total, setTotal] = useState<number>(0)
  const [DetailStr, setDetailStr] = useState<string>("")
  const [DetailId, setDetailId] = useState<string>("")
  /**
   * 列表
   */
  const getList = async () => {
    setLoading(true)
    const _data: any = await Api.Company.FlowLogTaskList(Query).finally(() => setLoading(false))
    if (_data) {
      setTableData(_data.records)
      setTotal(_data.total)
    }
  }

  useEffect(() => {
    props.flowId && getList()
  }, [props.flowId, Query])


  /**
   * 关闭
   */
  const close = () => {
    setOpen(false)
    const _timeOut = setTimeout(() => {
      props.close()
      clearTimeout(_timeOut)
    }, 500)
  }


  const columns: any = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: '节点ID',
      key: 'flowNode',
      dataIndex: 'flowNode',
    },
    {
      title: '节点名称',
      key: 'flowNodeName',
      dataIndex: 'flowNodeName',
    },
    {
      title: '状态',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      render: (text: string, record: any) => (
        <>
          {JSON.parse(record.detail)?.executeResp.code == 1 ? '失败' : '成功'}
        </>
      ),
    },
    {
      title: '操作人',
      dataIndex: 'operatorName',
      key: 'operatorName',
      width: 100,
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text: string) => (
        <>
          {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
        </>
      ),
    },
    {
      title: '操作',
      key: 'address',
      width: 100,
      render: (text: string, record: any, index: number) => (
        <>
          <Space size="middle">
            <a type="text" onClick={() => {
              setDetailStr(record.detail)
              setDetailId(record.id)
            }}>
              日志详情
            </a>
          </Space>
        </>
      ),
    },
  ]

  return (
    <Drawer
      open={Open}
      onClose={() => close()}
      destroyOnClose
      width={"100%"}
      keyboard={false}
      title={"流程执行详情-" + props.taskId}
      extra={
        <Button onClick={() => {
          setQuery({
            ...Query,
            current: 1
          })
        }}>刷新</Button>
      }
    >
      {DetailStr && <FlowLogDetail id={DetailId} json={DetailStr} close={() => setDetailStr("")}/>}
      <Table
        dataSource={TableData}
        loading={Loading}
        bordered
        rowKey={(row) => row.id}
        size={'small'}
        columns={columns}
        locale={{
          emptyText: <EmptyPanel description={"暂无数据"}/>,
        }}
        pagination={{
          current: Query.current,
          pageSize: Query.size,
          total: Total,
          showSizeChanger: true,
          locale: {},
          showTotal: (total, range) => `${range[0]}-${range[1]}, 共 ${total} 条`,
          onChange: (page, pageSize) => {
            setQuery({
              ...Query,
              current: page,
              size: pageSize
            })
          }
        }}
      />
    </Drawer>
  )
}

export default FlowTaskDetailLogs
